import React, { useEffect, useState } from 'react';

// material-ui
import { Typography } from '@material-ui/core';

// project imports
import NavGroup from './NavGroup';
import menuItem from './../../../../menu-items';
import { useSelector } from 'react-redux';

//-----------------------|| SIDEBAR MENU LIST ||-----------------------//
const filterItemsByRole = (items, role)=>{
    return items.filter(item=>{
        if(!item.roles) return true;
        if(item.roles.includes(role)){
            // Deep clone the item to avoid mutating the original
            const clonedItem = JSON.parse(JSON.stringify(item));
            if(clonedItem.children && clonedItem.children.length>0){
                clonedItem.children = filterItemsByRole(clonedItem.children, role);
            }
            return clonedItem;
        }
        return false;
    });
}
const MenuList = () => {
    const account = useSelector((state)=>state.account);
    const [items, setItems] = useState([]);

    useEffect(() => {
        if(account === null || account === undefined || account.user === null || account.user === undefined) return;
        const role = (account === null || account === undefined || account.user === null || account.user === undefined) ? "" : account.user.role;
        setItems(filterItemsByRole(menuItem.items, role));
     }, [account]);


    const navItems = items.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return navItems;
};

export default MenuList;
